import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedStaffAvailabilityExceptionList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface UseStaffAvailabilityExceptionListProps {
  staffId: string | undefined;
  limit?: string;
  offset?: string;
}

export default function useStaffAvailabilityExceptionList({
  staffId,
  limit = '20',
  offset = '0',
}: UseStaffAvailabilityExceptionListProps): UseInfiniteQueryResult<{
  data: PaginatedStaffAvailabilityExceptionList;
}> {
  const queryFn = ({
    pageParam = { limit, offset },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedStaffAvailabilityExceptionList>> => {
    const params = pageParam;
    if (staffId) {
      params.staff_id = staffId;
    }

    return client.get(`staff-availability-exceptions/`, {
      params,
    });
  };

  return useInfiniteQuery(['staff-availability-exceptions', staffId, limit, offset], queryFn, {
    enabled: !!staffId,
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}
